export default "__VITE_ASSET__CVgaYeNv__";